const isAll = v => v == null || v === '' || v === 'Todos';

const lc = s => String(s || '').toLowerCase();
const includesCI = (hay, needle) => lc(hay).includes(lc(needle));

function columnMatchesFilters(column, f) {
  if (
    !isAll(f.unitOperationGroupId)
    && Number(column.unitOperationGroupId) !== Number(f.unitOperationGroupId)
  ) {
    return false;
  }

  return true;
}

function cardMatchesFilters(card, f) {
  if (!isAll(f.id_project_group) && Number(card.id_project_group) !== Number(f.id_project_group)) {
    return false;
  }

  if (!isAll(f.priority) && Number(card.priority) !== Number(f.priority)) {
    return false;
  }

  if (!isAll(f.id_element) && Number(card.id_element) !== Number(f.id_element)) {
    return false;
  }

  if (!isAll(f.element_point_name)) {
    const hits = includesCI(card.element_point_name, f.element_point_name);
    if (!hits) return false;
  }

  if (!isAll(f.id_code_type_ug) && Number(card.id_code_type_ug) !== Number(f.id_code_type_ug)) {
    return false;
  }

  if (!isAll(f.id_code_group_ug) && Number(card.id_code_group_ug) !== Number(f.id_code_group_ug)) {
    return false;
  }

  if (!isAll(f.code_ug_name)) {
    const hits = includesCI(card.code_ug_name, f.code_ug_name);
    if (!hits) return false;
  }

  return true;
}

export function filterColumns(allData, filters) {
  if (!Array.isArray(allData)) return [];

  const board = allData.find(data => columnMatchesFilters(data, filters));

  return board?.columns ? board.columns : [];
}

export function filterCards(columns, filters) {
  if (!Array.isArray(columns)) return [];

  const filteredCards = columns.map(col => ({
    ...col,
    cards: (col.cards || []).filter(card => cardMatchesFilters(card, filters)),
  }));

  return filteredCards;
}
